module.exports = __webpack_public_path__ + "static/img/3.e9c1963.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcco/3.png
// module id = QhUw
// module chunks = 0